import { z } from 'zod';

export const LookupCnpjParamsSchema = z.object({
  cnpj: z.string().trim().min(14),
});

export type LookupCnpjParams = z.infer<typeof LookupCnpjParamsSchema>;

export const LookupCnpjSuggestedResponsibleSchema = z.object({
  name: z.string(),
  jobTitle: z.string().nullable(),
});

export type LookupCnpjSuggestedResponsible = z.infer<typeof LookupCnpjSuggestedResponsibleSchema>;

export const LookupCnpjResponseSchema = z.object({
  cnpjNormalized: z.string(),
  legalName: z.string(),
  tradeName: z.string().nullable(),
  stateRegistration: z.string().nullable(),
  addressStreet: z.string().nullable(),
  addressNumber: z.string().nullable(),
  addressComplement: z.string().nullable(),
  addressNeighborhood: z.string().nullable(),
  addressZipCode: z.string().nullable(),
  addressCityName: z.string().nullable(),
  addressStateCode: z.string().nullable(),
  addressStateId: z.uuid().optional(),
  addressCityId: z.uuid().optional(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  suggestedResponsibles: z.array(LookupCnpjSuggestedResponsibleSchema),
  source: z.enum(['directory', 'brasilapi', 'hubdesenvolvedor', 'apifull']),
  fetchedAt: z.iso.datetime(),
});

export type LookupCnpjResponse = z.infer<typeof LookupCnpjResponseSchema>;
